export function login ({ state, commit }, { email, username, password }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/login', { email, username, password, token_name: 'Android APP' })
      .then((response) => {
        commit('userLogin', response.data)
        axiosInstance.defaults.headers.common.Authorization = 'Bearer ' + response.data.token
        commit('userLoading')
        resolve(response.data)
      })
      .catch((error) => {
        commit('userLogout')
        commit('userLoading')
        reject(error)
      })
  })
}

export function password_reset ({ state, commit }, { old_password, password, password_confirmation }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/reset', { old_password, password, password_confirmation })
      .then((response) => {
        commit('userResetPass', response.data)
        commit('userLoading')
        resolve(response.data)
      })
      .catch((error) => {
        commit('userLoading')
        reject(error)
      })
  })
}

export function logout ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/logout')
      .then((response) => {
        commit('userLogout')
        commit('userLoading')
        resolve(response.data)
      })
      .catch((error) => {
        commit('userLogout')
        commit('userLoading')
        reject(error)
      })
  })
}

export function register ({ state, commit }, { name, email, password, rpassword }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/register_non_att', { name, email, password, password_confirmation: rpassword })
      .then((response) => {
        commit('userLoading')
        resolve(response.data)
      })
      .catch((error) => {
        commit('userLoading')
        reject(error)
      })
  })
}

export function register_att ({ state, commit }, { email }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/register', { email })
      .then((response) => {
        commit('userLoading')
        resolve(response.data)
      })
      .catch((error) => {
        commit('userLoading')
        reject(error)
      })
  })
}

export function getUserMenu ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/menu', )
      .then((response) => {
        commit('setMenu', response.data.menu)
        commit('common/setToday', response.data.today || '', {root: true})
        resolve(response.data)
      })
      .catch((error) => {
        commit('setMenuLoading')
        reject(error)
      })
  })
}

export function userinfo ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/user', )
      .then((response) => {
        commit('userLoading')
        commit('userData', response.data)
        resolve(response.data)
      })
      .catch((error) => {
        commit('userLoading')
        reject(error)
      })
  })
}

export function sendMessage ({ state, commit }, { user_id, message }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/user/message', { user_id, message })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

//export function online ({ state, commit }) {
//  return new Promise((resolve, reject) => {
//    axiosInstance.patch('/v1/users/online', )
//      .then((response) => {
//        resolve(response.data)
//      })
//      .catch((error) => {
//        reject(error)
//      })
//  })
//}
//
//export function offline ({ state, commit }) {
//  return new Promise((resolve, reject) => {
//    axiosInstance.patch('/v1/users/offline', )
//      .then((response) => {
//        resolve(response.data)
//      })
//      .catch((error) => {
//        reject(error)
//      })
//  })
//}
